import * as yup from "yup";

export const dailyScheduleSchema = yup.object().shape({
  day: yup.string().required("Day is required"),
  startTime: yup.date().required("Start Time is required"),
  endTime: yup.date().required("End Time is required"),
  timeSlotDurationMins: yup
    .number("Enter a valid duration in minutes")
    .typeError("Time Slot Duration is required")
    .positive("Enter a valid duration in minutes")
    .required("Time Slot Duration is required"),
});
